<div class="modal-dialog modal-dialog-centered modal-xl">
  <div class="modal-content">
    <div class="modal-header">
      <div class="card card-body">
        <h5 class="modal-title" i18n>Falha na pesquisa de placas</h5>
      </div>
    </div>
    <div class="modal-body label">
      <div class="row ml-3 font-size">
        <p i18n>Não foi possível consultar os dados da placa {{plate}}. Deseja pesquisar novamente ?</p>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="onCancel()" i18n>Cancelar</button>
      <button i18n (click)="onSubmit()" [ngClass]="{btn: true, 'btn-primary': true}">Confirmar</button>
    </div>
  </div>
</div>
